function RoleBadge({ role }) {
  if (!role || !role.name) return null

  const colors = {
    superadmin: 'bg-purple-100 text-purple-800',
    admin: 'bg-blue-100 text-blue-800',
    editor: 'bg-green-100 text-green-800',
    viewer: 'bg-gray-100 text-gray-800',
  }

  return (
    <span
      className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
        colors[role.name] || colors.viewer
      }`}
    >
      {role.name.charAt(0).toUpperCase() + role.name.slice(1)}
    </span>
  )
}

export default RoleBadge
